export { PreventBlockMergeExtension } from './prevent-block-merge.extension';
